import React, { ReactElement } from 'react';

import { Tooltip } from '@reckon-web/tooltip';

export const DisabledElementTooltip = ({
  children,
  content,
  childDisabled,
  label,
}: {
  children: ReactElement;
  content: string;
  childDisabled?: boolean;
  label: string;
}) => {
  if (childDisabled) {
    return (
      <Tooltip content={content}>
        <span tabIndex={0} aria-disabled aria-label={label}>
          {children}
        </span>
      </Tooltip>
    );
  }

  return children;
};
